import type { IAppBuild, IUseBuildsListQueryParams } from '~/types/build'

import config from '~/config'
import { paramsSerializer } from '~/utils/api'
import { request } from '~/utils/request'

export const getBuilds = (params?: IUseBuildsListQueryParams): Promise<IAppBuild[]> => {
  return request({
    url: `${config.BUILDS_API}/build?${paramsSerializer(params)}`,
  })
}

export const updateBuild = async ({ binary_file_id, ...payload }: IAppBuild): Promise<IAppBuild> => {
  return request({
    data: payload,
    method: 'PUT',
    url: `${config.BUILDS_API}/build/${binary_file_id}`,
  })
}
